import { useState } from "react";
import { ArrowRight, Camera, Check, Download, Film, UserRound } from "lucide-react";
import { Avatar, Brand, Surface } from "../components.jsx";
import { api, upload } from "../api.js";
import { useAuth } from "../auth.jsx";

export default function OnboardingPage() {
  const { user, setUser, refreshUser } = useAuth();
  const [username, setUsername] = useState(user.username);
  const [displayName, setDisplayName] = useState(user.displayName);
  const [bio, setBio] = useState(user.bio || "");
  const [avatar, setAvatar] = useState(null);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState("");

  const finish = async (event) => {
    event.preventDefault(); setWorking(true); setError("");
    try {
      let updated = await api("/v1/me", { method: "PATCH", body: { username, displayName, bio } });
      if (avatar) updated = await upload("/v1/me/avatar", avatar);
      updated = await api("/v1/me/onboarding/complete", { method: "POST" });
      setUser(updated); await refreshUser();
    } catch (caught) { setError(caught.message); }
    finally { setWorking(false); }
  };

  return (
    <div className="onboarding-page">
      <Brand />
      <div className="onboarding-grid">
        <div className="onboarding-copy"><span className="step-number">01</span><h1>Hazlo tuyo.</h1><p>Elige cómo te verá la gente. Después podrás importar Letterboxd desde Ajustes.</p><ul><li><Check />Nombre y usuario únicos</li><li><Film />Tus cuatro favoritas</li><li><Download />Importación cuando quieras</li></ul></div>
        <Surface as="form" className="onboarding-form" onSubmit={finish}>
          <label className="avatar-picker"><Avatar user={avatar ? { ...user, avatarURL: URL.createObjectURL(avatar) } : user} size={96} /><span><Camera />Elegir foto</span><input type="file" accept="image/*" onChange={(event) => setAvatar(event.target.files?.[0] || null)} /></label>
          <label className="field"><UserRound /><span>Nombre</span><input value={displayName} onChange={(event) => setDisplayName(event.target.value)} maxLength={60} required /></label>
          <label className="field"><span className="at-sign">@</span><span>Usuario</span><input value={username} onChange={(event) => setUsername(event.target.value.toLowerCase().replace(/[^a-z0-9_]/g, ""))} minLength={3} maxLength={20} required /></label>
          <label className="field field--textarea"><span>Bio</span><textarea value={bio} onChange={(event) => setBio(event.target.value)} maxLength={240} rows={3} /></label>
          {error ? <p className="form-error">{error}</p> : null}
          <button className="primary-button" disabled={working}>{working ? "Guardando…" : <>Entrar en Rollo <ArrowRight /></>}</button>
        </Surface>
      </div>
    </div>
  );
}
